import { ThunkAction } from 'redux-thunk';
import { Dispatch } from 'react-redux';
// @ts-ignore
import Notify from 'store/utils/Notify';
// @ts-ignore
import ErrorHandler from 'store/utils/ErrorHandler';
import * as types from './actionTypes';
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-named-default
import { fetchTemplatesRequest } from './api';
import {
  PartialRootState,
  ProjectTemplatesActions,
  ProjectTemplate,
} from './types';

// Exporting only this actionCreator in order
// to import it in the spec file and test it
export const fetchProjectTemplatesListRequest = () => ({
  type: types.FETCH_PROJECT_TEMPLATES_REQUEST,
});

const fetchProjectTemplatesListSuccess = (items: ProjectTemplate[]) => ({
  type: types.FETCH_PROJECT_TEMPLATES_SUCCESS,
  payload: items,
});

const fetchProjectTemplatesListError = (error: string) => ({
  type: types.FETCH_PROJECT_TEMPLATES_ERROR,
  error,
});

export type ThunkResult<R> = ThunkAction<
  R,
  PartialRootState,
  undefined,
  ProjectTemplatesActions
>;

export const fetchProjectTemplatesList = (): ThunkResult<void> => async (
  dispatch: Dispatch<ProjectTemplatesActions>,
) => {
  try {
    dispatch(fetchProjectTemplatesListRequest());

    const { data } = await fetchTemplatesRequest();

    dispatch(fetchProjectTemplatesListSuccess(data.results));
  } catch (error) {
    Notify.error({
      title: `Unable to fetch Project Templates.`,
      description: ErrorHandler.getNotificationError(error),
    });
    dispatch(fetchProjectTemplatesListError(error));
  }
};
